module.exports = __webpack_public_path__ + "img/24_14.7d112cd9.png";